import SEOHead, {
  generateOrganizationSchema,
  generateWebSiteSchema,
  generateWebPageSchema,
} from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import MovieSection from './components/MovieSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  const schema = {
    ...generateOrganizationSchema(),
    ...generateWebSiteSchema(),
    ...generateWebPageSchema(
      '日韩影视网 - 免费日韩电影在线观看 | 韩国电影免费与日本电影免费高清大片',
      '日韩影视网提供免费日韩电影在线观看服务，涵盖日本电影免费、韩国电影免费及最新日韩电影。高清画质急速播放，经典大片和新片速递一网打尽。',
      'https://www.rihanyingshi.com',
    ),
  };

  return (
    <>
      <SEOHead
        title="日韩影视网 - 免费日韩电影在线观看 | 韩国电影免费与日本电影免费高清大片"
        description="日韩影视网提供免费日韩电影在线观看服务，涵盖日本电影免费、韩国电影免费及最新日韩电影。高清画质急速播放，经典大片和新片速递一网打尽。"
        keywords="日韩影视网,日韩电影在线,免费日韩电影,日韩电影高清,韩国电影免费,日本电影免费,最新日韩电影,高清流畅,急速播放"
        canonicalUrl="https://www.rihanyingshi.com"
        ogType="website"
        schema={schema}
        lastModified="2026-08-03"
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <MovieSection
          title="热门推荐"
          subtitle="全网热播日韩大片，观众好评如潮"
          filterKey="isHot"
          viewAllLink="/category/japanese-movie"
        />
        <FeaturesSection />
        <MovieSection
          title="最新上线"
          subtitle="紧跟日韩影视潮流，最新影片抢先看"
          filterKey="isNew"
        />
        <MovieSection
          title="经典大片"
          subtitle="历久弥新的日韩经典电影，值得反复回味"
          filterKey="isClassic"
          viewAllLink="/category/korean-movie"
        />
      </main>

      <Footer />
    </>
  );
}